export interface DaySchedule {
  dayOfWeek: string;
  startTime: string;
  endTime: string;
}

export interface ScheduleException {
  type: string;
  description: string;
  scheduleImpact: string;
}

export interface BASScheduleEntry {
  dayOfWeek: string;
  startTime: string;
  endTime: string;
  equipment?: string;
}

export interface HVACSpace {
  id: string;
  organizationId: string;
  buildingId: string;
  programId: string;
  name: string;
  type: string;
  occupied: boolean;
  squareFeet?: number;
  primaryEquipment?: string[];
  leaseSchedule?: DaySchedule[];
  leaseExceptions?: ScheduleException[];
  basSchedule?: BASScheduleEntry[];
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
}

export const SPACE_TYPES = [
  { value: 'floor', label: 'Floor' },
  { value: 'zone', label: 'Zone' },
  { value: 'wing', label: 'Wing' },
  { value: 'suite', label: 'Suite' },
  { value: 'common_area', label: 'Common Area' },
];

export const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
